import { render, staticRenderFns } from "./marker-card.vue?vue&type=template&id=05889290&scoped=true&"
import script from "./marker-card.ts?vue&type=script&lang=ts&"
export * from "./marker-card.ts?vue&type=script&lang=ts&"
import style0 from "./marker-card.scss?vue&type=style&index=0&id=05889290&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05889290",
  null
  
)

export default component.exports